import { render, staticRenderFns } from "./HomeBannerImage.vue?vue&type=template&id=0047c71e&scoped=true"
import script from "./HomeBannerImage.js?vue&type=script&lang=js&external"
export * from "./HomeBannerImage.js?vue&type=script&lang=js&external"
import style0 from "./HomeBannerImage.scss?vue&type=style&index=0&id=0047c71e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047c71e",
  null
  
)

export default component.exports